export default __webpack_public_path__ + "static/media/suggestion.d57790dd.png";